export default function (statusCode, statusText) {
  let status;
  if (statusCode == undefined) {
    return '';
  }
  switch (statusCode) {
    case 0:
      status = 'warning';
      break;
    case 1:
      status = 'success';
      break;
    case 2:
      status = 'danger';
      break;
    case 3:
      status = 'success';
      break;
    case 4:
      status = 'success';
      break;
    case 5:
      status = 'success';
      break;
    case 6:
      status = 'success';
      break;
    case 7:
      status = 'warning';
      break;
    default:
      status = 'warning';
      break;
  }
  return `<span class="bbw-badge kt-badge kt-badge--outline kt-badge--${status} text-nowrap custom-order-info-card__provider-status-badge" data-aid="order-provider-status">${statusText}</span>`;
}
